export default function Canvas_ClearRect() {
  return (
    <div>
      <h1>Canvas_ClearRect Component</h1>
    </div>
  );
}
